<template>
  <div>
    <authorisation-wrapper
      :resource="ACCOUNTS"
      :action="WRITE"
      v-slot="{ isAllowed: allowedWriteAccounts }"
    >
      <cl-button
        :variant="'secondary'"
        type="button"
        :disabled="loading"
        :readonly="!allowedWriteAccounts"
        data-test-id="msps-data-table-add"
        @on-click="modalVisible = true"
      >
        {{ t("add-msp") }}
      </cl-button>
      <t-add-msps-index
        v-if="modalVisible"
        :visible="modalVisible"
        :parent-uuid="parentUuid"
        @on-create="onCreated"
        @on-close="onModalClose"
      />
    </authorisation-wrapper>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import TAddMspsIndex from "@/modals/t-add-msps/t-add-msps.index.vue";
import {
  ACCOUNTS,
  AuthorisationWrapper,
  useAuthorisation,
  WRITE,
} from "@/authorisation";

const { t } = useI18n();

interface Props {
  loading: boolean;
}
defineProps<Props>();

const emit = defineEmits(["created"]);

const modalVisible = ref<boolean>(false);

const route = useRoute();
const router = useRouter();

const { hasPermission } = useAuthorisation();
const parentUuid = computed(() => {
  const param = route.params.orgUuid;
  return typeof param === "string" ? param : null;
});

onMounted(() => {
  if (!hasPermission(WRITE, ACCOUNTS)) {
    return;
  }

  if (route.query.openModal) {
    modalVisible.value = true;
  }
});

const onModalClose = () => {
  modalVisible.value = false;
  const newQuery = { ...route.query };
  delete newQuery.openModal;
  router.replace({ query: newQuery });
};

const onCreated = () => {
  modalVisible.value = false;
  emit("created");
};
</script>
